<template>
  <div class="row">
    <div class="col-md-12">
      <h3 class="m-b-2">Return Authorization</h3>
      <div class="row">
        <div class="col-md-4">
          <p>Return Authorization #:
            <strong class="pull-right">{{returnAuthorization.id}}</strong>
          </p>
          <p>Region:
            <strong class="pull-right">{{returnAuthorization.region}}</strong>
          </p>
          <p>Invoice #:
            <strong
                class="pull-right">{{returnAuthorization.invoice_id}}</strong>
          </p>
          <p>Reason Code:
            <strong
                class="pull-right">{{returnAuthorization.return_status}}</strong>
          </p>
        </div>
        <div class="col-md-4">
          <p>Warehouse:
            <strong
                class="pull-right">{{returnAuthorization.warehouse_code}}</strong>
          </p>
          <p>Remarks/Notes:
            <strong class="pull-right">{{returnAuthorization.note}}</strong></p>
          <p>Misc:
            <strong class="pull-right">{{returnAuthorization.misc |
              currency}}</strong>
          </p>
          <p>Freight:
            <strong class="pull-right">
              {{returnAuthorization.freight | currency}}</strong>
          </p>
        </div>
        <div class="col-md-4">
          <p>Currency:
            <strong class="pull-right">{{returnAuthorization.currency}}</strong>
          </p>
          <p>Tax 2:
            <strong class="pull-right">{{returnAuthorization.tax |
              currency}}</strong>
          </p>
          <p>Type:
            <strong class="pull-right">{{returnAuthorization.tax_code}}</strong>
          </p>
        </div>
      </div>
      <h3 class="m-b-2">Line Items</h3>
      <el-table :data="returnAuthorization.items">
        <el-table-column label="Style"
                         prop="style"
                         align="center"
                         header-align="center"/>
        <el-table-column label="Color"
                         prop="color"
                         align="center"
                         header-align="center"/>
        <el-table-column label="Size"
                         prop="size"
                         align="center"
                         header-align="center"/>
        <el-table-column label="Quality"
                         prop="quality"
                         align="center"
                         header-align="center"/>
        <el-table-column label="Quantity"
                         prop="quantity"
                         align="center"
                         header-align="center"/>
        <el-table-column label="Unit Price"
                         prop="unit_price"
                         align="center"
                         header-align="center"/>
      </el-table>
    </div>
    <div class="col-md-12 text-right">
      <hr>
      <app-spinner v-if="isLoading"/>
      <template v-else>
        <template v-if="isReturningToWarehouse">
          <h4 class="text-danger">
            Cannot Process Refund – provide RA number
            (<strong class="text-success">{{returnAuthorization.id}}</strong>)
            to customer for return.
          </h4>
        </template>
        <template v-else-if="!refunded">
          <div class="row">
            <div class="col-md-9">
              <refund-transactions :transactions="(draftRefund && draftRefund.transactions) || []"/>
            </div>
            <div class="col-md-3">
              <el-checkbox v-model="notify"
                           :value="notify"
                           label="Notify Customer"
                           border/>
              <el-button
                  @click.native="refund"
                  type="success"
                  round>Process Refund
                <strong>{{refundValue | currency}}</strong>
              </el-button>
            </div>
          </div>
        </template>
        <template v-else-if="refunded">
          <order-refund-transactions :refund="refunded"/>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
  import {mapState, mapActions, mapMutations} from 'vuex';
  import {currency} from '../../../filters';
  import {
    ORDER_RETURN_CREATE_SHOPIFY_REFUND, ORDER_RETURN_SET_HIDE_BUTTON,
    ORDER_RETURN_SET_NOTIFY,
  } from '../../../store/modules/order/return/types';
  import AppSpinner from '../../ui/AppSpinner';
  import OrderRefundTransactions from '../Shared/OrderRefundTransactions';
  import RefundTransactions from '../Shared/RefundTransactions';
  import {ORDER_SET_HIDE_BUTTON} from "../../../store/types";
  import {notify} from "../../../utils";

  export default {
    name: 'OrderReturnSuccessPage',
    components: {
      AppSpinner,
      OrderRefundTransactions,
      RefundTransactions,
    },
    filters: {
      currency,
    },
    computed: {
      ...mapState({
        isLoading: state => state.orderReturn.loading,
        isReturningToWarehouse: state => state.orderReturn.warehouse,
        draftRefund: state => state.orderReturn.draftRefund,
        returnAuthorization: state => state.orderReturn.returnAuthorization,
        notifyRefund: state => state.orderReturn.notifyRefund,
          region: state => state.orderReturn.region,
      }),
      refundValue() {
        const reducer = (amount, transaction) => {
          return amount + Number(transaction.amount)
        };
        return this.draftRefund ? this.draftRefund.transactions.reduce(reducer, 0) : 0;
      },
      notify: {
        set(value) {
          this.setNotifyRefund(value);
        },
        get() {
          return this.notifyRefund;
        },
      },
    },
    methods: {
      ...mapActions({
        refundShopify: ORDER_RETURN_CREATE_SHOPIFY_REFUND,
      }),
      ...mapMutations({
        setNotifyRefund: ORDER_RETURN_SET_NOTIFY,
        hideButton: ORDER_RETURN_SET_HIDE_BUTTON
      }),
      refund(event) {
        event.currentTarget.disabled = true;

        this.refundShopify().then(response => {
          return response.data.refund;
        }).then(refund => {
          this.hideButton(false);
          this.refunded = refund.refund || refund;
          this.refundClicked=true;
        });
      },
      preventNav(event) {
        if (this.refundClicked){
          return;
        }
        const warningMsg = "Please click refund before you leave the page!";
        notify(warningMsg, 'danger');
        event.preventDefault()
        event.returnValue = warningMsg;
        return warningMsg;
      },
    },
    data() {
      return {
        refunded: null,
        refundClicked:false,
      };
    },
    created() {
      this.hideButton(true);
      if (!this.draftRefund) {
        this.$router.push({path: 'update'});
      }
    },
    mounted() {
      window.scrollTo(0, 0);
    },
    beforeMount() {
      if (this.refundAmount===0 || this.isReturningToWarehouse || this.region==='amazon_usa' ){
        this.refundClicked = true;
      }
      window.addEventListener("beforeunload", this.preventNav)
      this.$once("hook:beforeDestroy", () => {
        window.removeEventListener("beforeunload", this.preventNav);
      })
    },
    beforeRouteLeave(to, from, next) {
      if (!this.refundClicked && this.draftRefund){
        const warningMsg = "Please click refund before you leave the page!";
        notify(warningMsg, 'danger');
      }else{
        this.hideButton(false);
        next();
      }
    },
  };
</script>
